// extracted by mini-css-extract-plugin
export default {"sidebarToggleButton":"ListSidebar-module__sidebarToggleButton--dHcFh","sidebarHeading":"ListSidebar-module__sidebarHeading--KvEC0","dialog":"ListSidebar-module__dialog--CaIop"};